import { z } from 'zod';

export const ApiError = z.object({
  code: z.string(),
  message: z.string(),
  threadId: z.string().optional(),
  details: z.unknown().optional(),
});
export type ApiError = z.infer<typeof ApiError>;
